import React from 'react';
import { IShapeProps } from './types';
import { IShapeEllipseAttributes } from '../../../types';
import { Ellipse } from 'react-konva';
import Konva from 'konva';

const EllipseCanvasElement: React.FC<IShapeProps> = (props) => {

  let attributes = (props.element.attributes as IShapeEllipseAttributes);
  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.Ellipse>);

  return (
    <Ellipse
      {...props.renderProps}
      ref={shapeRef}
      radiusX={attributes.width! / 2}
      radiusY={attributes.height / 2}
    />
  );
}

export default EllipseCanvasElement